import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UpdatePasswordResponse } from 'types/profile';

interface ProfileState {
  loading?: boolean;
  updatePasswordResponse?: UpdatePasswordResponse;
}

const initialState: ProfileState = {
  loading: false,
};

const register = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    updatePasswordStart(state) {
      state.loading = true;
    },
    updatePasswordEnd(state) {
      state.loading = false;
    },
    updatePasswordError(state, action: PayloadAction<UpdatePasswordResponse>) {
      state.loading = false;
      state.updatePasswordResponse = action.payload;
    },
    setUpdatePasswordResponse(
      state,
      action: PayloadAction<UpdatePasswordResponse>,
    ) {
      state.loading = false;
      state.updatePasswordResponse = action.payload;
    },
  },
});

export const {
  updatePasswordStart,
  updatePasswordEnd,
  updatePasswordError,
  setUpdatePasswordResponse,
} = register.actions;

export default register.reducer;
